import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const rangeSlider = function (scope) {
    scope = scope ? scope + ' ' : '';

    $(scope + '.js-rangeslider').each(function () {
        var $this = $(this);
        var $val = $($this.data('output'));

        $val.on('change', function (e) {
            // remove everying that is not at digit
            var formattedValue = e.target.value.replace(/\D/g, '');
            // update the rangeslider value
            $this.val(formattedValue).change();
        });

        $this.rangeslider({
            polyfill: false,
            onInit: function () {},
            onSlide: function (position, value) {
                if ($val.length) {
                    if ($val.get(0).tagName === 'INPUT') {
                        $val.val(value);
                    } else {
                        $val.text(value);
                    }
                }

                if ($this.data('slide-callback')) {
                    const fn = window[$this.data('slide-callback')];
                    if (typeof fn === 'function') {
                        fn.apply(this, [position, value]);
                    }
                }

                // Also dispatch event that can be listened for.
                var event = new Event('slide');
                $this.get(0).dispatchEvent(event);
            },
            onSlideEnd: function (position, value) {
                if ($this.data('slide-end-callback')) {
                    const fn = window[$this.data('slide-end-callback')];
                    if (typeof fn === 'function') {
                        fn.apply(this, [position, value]);
                    }
                }

                // Also dispatch event that can be listened for.
                var event = new Event('slide-end');
                $this.get(0).dispatchEvent(event);
            }
        });

    });
    // Listen for when a slider is made visible (from display: none to visible).
    // When made visible, update the slider size.
    const sliders = document.querySelectorAll(scope + '.js-rangeslider');
    sliders.forEach((slider) => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const isVisible = entry.contentRect.width !== 0;
                if (isVisible) {
                    $(slider).rangeslider();
                }
            }
        });
        resizeObserver.observe(slider);
    });
};

export default {
    init: rangeSlider
};

App.Util.rangeSlider = rangeSlider;
